import { createGlobalStyle } from 'styled-components'
import { normalize } from 'styled-normalize'

import sharpSansBold from '../assets/fonts/SharpSans/SharpSans-Bold.woff2'
import sharpSans from '../assets/fonts/SharpSans/SharpSans-Book.woff2'
import sharpSansLight from '../assets/fonts/SharpSans/SharpSans-Light.woff2'
import sharpSansMedium from '../assets/fonts/SharpSans/SharpSans-Medium.woff2'
import sharpSansSemiBold from '../assets/fonts/SharpSans/SharpSans-Semibold.woff2'

import sharpSansBoldFallback from '../assets/fonts/SharpSans/SharpSans-Bold.woff'
import sharpSansFallback from '../assets/fonts/SharpSans/SharpSans-Book.woff'
import sharpSansLightFallback from '../assets/fonts/SharpSans/SharpSans-Light.woff'
import sharpSansMediumFallback from '../assets/fonts/SharpSans/SharpSans-Medium.woff'
import sharpSansSemiBoldFallback from '../assets/fonts/SharpSans/SharpSans-Semibold.woff'

export const GlobalStyle = createGlobalStyle`
  ${normalize}

  body {
    @font-face {
     font-family: 'Sharp Sans';
     font-style: normal;
     font-weight: 300;
     font-display: swap;
     src: local('Sharp Sans Light'), local('SharpSans-Light'), url(${sharpSansLight}) format('woff2'),
     url(${sharpSansLightFallback}) format('woff');
    };
    @font-face {
     font-family: 'Sharp Sans';
     font-style: normal;
     font-weight: normal;
     font-display: swap;
     src: local('Sharp Sans Book'), local('SharpSans-Book'), url(${sharpSans}) format('woff2'),
     url(${sharpSansFallback}) format('woff');
    };
    @font-face {
     font-family: 'Sharp Sans';
     font-style: normal;
     font-weight: 500;
     font-display: swap;
     src: local('Sharp Sans Medium'), local('SharpSans-Medium'), url(${sharpSansMedium}) format('woff2'),
     url(${sharpSansMediumFallback}) format('woff');
    };
    @font-face {
     font-family: 'Sharp Sans';
     font-style: normal;
     font-weight: 600;
     font-display: swap;
     src: local('Sharp Sans Semibold'), local('SharpSans-Semibold'), url(${sharpSansSemiBold}) format('woff2'),
     url(${sharpSansSemiBoldFallback}) format('woff');
    };
    @font-face {
     font-family: 'Sharp Sans';
     font-style: normal;
     font-weight: bold;
     font-display: swap;
     src: local('Sharp Sans Bold'), local('SharpSans-Bold'), url(${sharpSansBold}) format('woff2'),
     url(${sharpSansBoldFallback}) format('woff');
    };

    margin: 0;
    font-family: ${({ theme }) => theme.fontFamily};
    font-size: ${({ theme }) => theme.fontSize};
    font-weight: ${({ theme }) => theme.fontWeight};

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #root {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .text-center {
    text-align: center;
  }

  .text-right {
    text-align: right;
  }

  .text-left {
    text-align: left;
  }

  .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
